__turbopack_context__.v({
  "img": "Products-module__Y5LSAW__img",
  "info": "Products-module__Y5LSAW__info",
  "link": "Products-module__Y5LSAW__link",
  "moveRight": "Products-module__Y5LSAW__moveRight",
  "product": "Products-module__Y5LSAW__product",
  "products": "Products-module__Y5LSAW__products",
  "section": "Products-module__Y5LSAW__section",
  "spec": "Products-module__Y5LSAW__spec",
  "title": "Products-module__Y5LSAW__title",
});
